import { IsActiveMatchOptions } from '@angular/router';

export type NavigationItem = {
  id: string;
  label: string;
  description?: string;
  route?: string;
  icon?: string;
  badge?: string;
  children?: NavigationItem[];
  disabled?: boolean;
  expanded?: boolean;
  activeOptions?: { exact: boolean } | IsActiveMatchOptions;
  link?: string;
};

export const NAVIGATION: NavigationItem[] = [
  {
    id: 'jobs',
    label: 'Jobs',
    description: 'Browse and search jobs',
    route: '/jobs',
    children: [
      {
        id: 'search-jobs',
        label: 'Search Jobs',
        icon: 'search',
        route: '/jobs',
      },
      {
        id: 'browse-jobs',
        label: 'Browse Jobs',
        icon: 'list',
        route: '/browse-jobs',
      },
      {
        id: 'companies',
        label: 'Trucking Companies',
        icon: 'truck',
        route: '/companies',
      },
    ],
  },
  {
    id: 'news',
    label: 'News',
    description: 'Trucking News and Events',
    link: 'https://truckdriversus.com/blog',
    children: [
      {
        id: 'news-in-trucking',
        label: 'News in Trucking',
        icon: 'newspaper',
        link: 'https://truckdriversus.com/blog',
      },
      {
        id: 'haul-of-fame',
        label: 'Haul of Fame',
        icon: 'badge',
        link: 'https://truckdriversus.com/heroes',
      },
      {
        id: 'events',
        label: 'Events',
        icon: 'calendar',
        link: 'https://truckdriversus.com/events',
      },
    ]
  },
  {
    id: 'carriers',
    label: 'For Carriers',
    description: 'Hire better with TDUSA',
    children: [
      {
        id: 'advertise',
        label: 'Post a Job',
        icon: 'newspaper',
        link: 'https://truckdriversus.com/advertise',
      },
    ],
  },
  {
    id: 'drivers',
    label: 'For Drivers',
    description: 'Additional resources for drivers',
    children: [
      {
        id: 'driver-pay',
        label: 'Driver Pay Info',
        icon: 'banknote',
        link: 'https://truckdriversus.com/driver-pay',
      },
      {
        id: 'career-driver-ai',
        label: 'Career Driver AI',
        icon: 'bot',
        link: 'https://mobileapp.careerdriver.ai/',
      },
      {
        id: 'blue-parrott',
        label: 'Blue Parrott',
        icon: 'headset',
        link: 'https://www.blueparrott.com/',
      },
      {
        id: 'truck-parking-club',
        label: 'Truck Parking Club',
        icon: 'fuel',
        link: 'https://truckdriversus.com/truck-parking-club',
      },
      {
        id: 'women-in-trucking',
        label: 'Women in Trucking',
        icon: 'venus',
        link: 'https://www.womenintrucking.org/',
      },
      {
        id: 'trckrlife-apparel',
        label: 'Trckrlife Apparel',
        icon: 'shirt',
        link: 'https://trckrlifeapparel.com/',
      },
    ],
  },
  {
    id: 'contact',
    label: 'Contact Us',
    link: 'https://truckdriversus.com/contact',
  },
  {
    id: 'apply-now',
    label: 'Apply Now',
    route: '/',
  },
];
